import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import LoginModal from '~/login/components/LoginModal';
import { createDataAutoTagString } from '~/shared/utils/createDataAutoTagString';
import { getBuilderDataAnalyticsProps } from '~/shared/utils/getBuilderDataAnalyticsProps';
import { Button } from '~/techstyle-shared/react-components';

const PrecedingText = styled.span`
  font-weight: 600;
`;

const ActionText = styled.span`
  ${({ theme }) => theme.builderHeader.signInWithModal.actionText};
`;

const SignInButton = styled(Button).attrs({
  variant: 'unstyled',
})`
  ${({ theme }) => theme.builderHeader.signInWithModal.signInButton};
`;

function BuilderSignInWithModal({ precedingText, actionText, dataAnalytics }) {
  return (
    <LoginModal
      trigger={
        <SignInButton
          data-builder-component-type="sign_in_with_modal"
          data-autotag={createDataAutoTagString('sign_in_with_modal')}
          {...getBuilderDataAnalyticsProps(dataAnalytics)}
        >
          {precedingText && <PrecedingText>{precedingText}</PrecedingText>}
          <ActionText>{actionText}</ActionText>
        </SignInButton>
      }
    />
  );
}

BuilderSignInWithModal.propTypes = {
  actionText: PropTypes.string,
  dataAnalytics: PropTypes.shape({
    category: PropTypes.string,
    label: PropTypes.string,
  }),
  precedingText: PropTypes.string,
};

export default BuilderSignInWithModal;
